import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';

export default () => {
  const { gql, useQuery, useMutation } = useAppContext();

  const UsersAvailabilityFragment = gql`
fragment UsersAvailabilityFragment on UsersAvailability {
  id
  userId
  status
  conciergeOption
  appointmentTypes
  duration
  user {
    id
    firstName
    lastName
    fullName
  }
  availability {
    id
    from
    hour
  }
}  
  `;

  const AvailabilityFragment = gql`
fragment AvailabilityFragment on Availability {
  id
  from
  to
  hour
  disabled
  hasFreeSlot
  allBooked
  statusAverage
  firstAvailableSlot {
    ...UsersAvailabilityFragment
  }
  usersAvailabilities {
    ...UsersAvailabilityFragment
  }
}
${UsersAvailabilityFragment}
  `;

  const AvailabilityScopedUsersAvailabilitiesFragment = ({ forBooking }) => gql`
fragment AvailabilityFragment on Availability {
  id
  from
  to
  hour
  disabled
  hasFreeSlot
  allBooked
  statusAverage
  firstAvailableSlot${forBooking ? '(appointmentType: $appointmentType)' : ''} {
    ...UsersAvailabilityFragment
  }
  usersAvailabilities {
    ...UsersAvailabilityFragment
  }
}
${UsersAvailabilityFragment}
  `;

  const UpdateAvailabilityGql = gql`
  mutation updateAvailability($input: AvailabilityInput!) {
    updateAvailability(input: $input) {
      availability {
        ...AvailabilityFragment
      }
    }
  }
  ${AvailabilityFragment}  
  `;

  const useUpdateAvailabilityMutation = () => useMutation(UpdateAvailabilityGql);

  return {
    AvailabilityFragment,
    UsersAvailabilityFragment,
    AvailabilityScopedUsersAvailabilitiesFragment,
    useUpdateAvailabilityMutation,
  };
};
